module.exports = __webpack_public_path__ + "img/ship.e5658543.png";